import { render, staticRenderFns } from "./merchantsRecords.vue?vue&type=template&id=613e344a&scoped=true&"
import script from "./merchantsRecords.vue?vue&type=script&lang=js&"
export * from "./merchantsRecords.vue?vue&type=script&lang=js&"
import style0 from "./merchantsRecords.vue?vue&type=style&index=0&id=613e344a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613e344a",
  null
  
)

export default component.exports